import { atom } from 'jotai';

export const pageObjectIdAtom = atom<string | undefined>(undefined);
export const appActionAtom = atom<string | undefined>(undefined);
